export const AddTime = ({ size = 36, color = 'currentColor' }: { size?: number; color?: string }) => (
  <svg width={size} height={size} viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1995_1121)">
      <path
        d="M128 128L67.2 82.4C66.2064 81.6548 65.4 80.6885 64.8446 79.5777C64.2892 78.4669 64 77.242 64 76V40C64 37.8783 64.8429 35.8434 66.3431 34.3431C67.8434 32.8429 69.8783 32 72 32H184C186.122 32 188.157 32.8429 189.657 34.3431C191.157 35.8434 192 37.8783 192 40V75.64C191.996 76.8735 191.707 78.0894 191.155 79.1927C190.604 80.296 189.805 81.2568 188.82 82L128 128Z"
        stroke={color}
        strokeWidth="24"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135.237 118.428C130.969 115.201 125.08 115.19 120.8 118.4L60 164C57.5161 165.863 55.5 168.279 54.1115 171.056C52.7229 173.833 52 176.895 52 180V216C52 221.304 54.1071 226.391 57.8579 230.142C61.6086 233.893 66.6957 236 72 236H178.062C176.115 233.091 174.58 229.882 173.542 226.458C165.494 224.018 158.638 218.837 154.062 212H76V182L127.971 143.022L158.779 166.312C162.869 162.295 167.914 159.248 173.542 157.542C174.359 154.849 175.482 152.289 176.872 149.904L135.237 118.428Z"
        fill={color}
      />
      <path d="M184 192H232" stroke={color} strokeWidth="24" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M208 168V216" stroke={color} strokeWidth="24" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1995_1121">
        <rect width="256" height="256" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
